import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnBuyStep_11 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnBuyStep_11 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_11) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_10);
    onReset(["timeIntervalTypeCommunication"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_12);
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="communication"
        text="Удобное время для связи:"
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_11;
